//#region src/lead_time_source.ts
var LeadTimeSource = /* @__PURE__ */ function(LeadTimeSource) {
	LeadTimeSource["Location"] = "location";
	LeadTimeSource["MenuItem"] = "menu-item";
	return LeadTimeSource;
}(LeadTimeSource || {});
//#endregion
export { LeadTimeSource };

//# sourceMappingURL=lead_time_source.js.map